import CEGuidelineCognitoLogin from './../ui-web-components/LoginComponent/LoginComponent.js';
import defaultConfigForCognito from "./../constants/cognitoConfig";

export default (() => {   
    window.customElements.get('ce-guideline-cognito-login') || window.customElements.define('ce-guideline-cognito-login', CEGuidelineCognitoLogin);
    window.config = defaultConfigForCognito;
})();
